<template>
    <div class="addEmployeeVue">
        <div class="o-main-content-area" v-if="isEmployeeAllowed">
            <div class="row c-responsive-fixwidth">          
                <div class="col-md-6 o-main-content-area">
                    <h1 class="h1">{{ $t('edit_employee') }} </h1>
                    <div class="employee-summary-profile employee-summary-profile--inline">
                        <div class="employee-summary-profile-pic c-user__profile-pic">
                            <img v-if="profileImage != '' && profileImage != 'NULL'" :src="(profileImage)" />
                            <img v-if="profileImage && (profileImage == '' || profileImage == 'NULL')" src="static/assets/images/user1.png" />  
                        </div> 
                        <div class="summary-info o-schedule-user">
                            <h1 class="h1">
                                {{ employeeDetails.employable ? (employeeDetails.employable.first_name+" "+employeeDetails.employable.last_name): "NA" }} 
                                {{ employeeDetails.employable && employeeDetails.employable.display_name && employeeDetails.employable.display_name != 'null' ? '(' + (employeeDetails.employable.display_name) + ')': "" }}
                            </h1>
                            <div>
                                <p v-if="employeePhone.length > 0">
                                    <span v-for="(phone,index) in employeePhone" :key="index" v-if="phone.phone_number && phone.phone_number != '' && phone.phone_number !='0'">
                                        <span v-if="phone.label && (phone.label=='Home phone' || 'Home Phone' || 'Cell phone' || 'Cell Phone')">
                                            {{ $t(phone.label) }}:
                                        </span> 
                                        <span v-else>{{ phone.label }}:</span>
                                        <!-- <span class="header-value">{{ phone.phone_number }}</span> -->
                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="header-value phone-number-display">
                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                        </a>
                                    </span>
                                </p>
                                <p v-else>
                                    <span>{{ $t('home_phone') }}:</span><span class="header-value">NA</span>
                                    <span>{{ $t('cell_phone') }}:</span><span class="header-value">NA</span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <span>Status:</span>
                                    <span class="header-value">{{ employeeDetails.employee_status?employeeDetails.employee_status.name:'NA' }},</span>
                                    <span>Seniority:</span>
                                    <span class="header-value">{{ employeeDetails.seniority?employeeDetails.seniority:'NA' }}</span>
                                </p>                            
                            </div>                     
                        </div>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li v-if="getPower('employeeSearch')">
                            <input autocomplete="off" type="text" v-model="search_query" class="form-control search-input-employee" :placeholder="$t('search')" name="Search">
                        </li>

                        <li><a href="javascript: void(0)" @click="goToEmployee()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i>{{ $t('back') }} </a></li>

                        <li v-if="disabledFrelenceUser()"><a href="javascript: void(0)" @click="viewSchedule()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-eye"></i>{{ $t('schedule') }} </a></li>

                        <li v-if="(wishlistLock || ignorelistLock) && disabledFrelenceUser()"><a href="javascript: void(0)" @click="goToWishlist()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-star"></i>{{ $t('wishlist') }} </a></li>
                        
                        <li><a href="javascript: void(0)" @click="uploadService()" :class="{'isDisabled':btnLoading}" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i>{{ $t('save')}} </a></li>
                    </ul>

                </div>
            </div>

            <div class="edit-view" v-if="searchOpen&&!btnLoading">
                <div class="c-common-space c-responsive-fixwidth">
                    <div class="o-tab-area clearfix">
                        <div class="col-md-12 o-no-padding">
                            <ul class="o-tab-view o-tab-view--text">

                                    <li>
                                        <a href="javascript: void(0)" :class="(tab=='personal')?'active':'custom-deactive-btn'" @click="changeTab('personal')">
                                            {{ $t('personal_information') }} 
                                        </a>
                                    </li>

                                    <li v-if="disabledFrelenceUser()">
                                        <a href="javascript: void(0)" :class="(tab=='skill')?'active':'custom-deactive-btn'" @click="changeTab('skill')">
                                            {{ $t('skillset') }} 
                                        </a>
                                    </li>

                                    <li>
                                        <a href="javascript: void(0)" :class="(tab=='availability')?'active':'custom-deactive-btn'" @click="changeTab('availability')">
                                            {{ $t('unavailability') + " & " +$t('vacation') }}
                                        </a>
                                    </li>

                                    <li v-if="disabledFrelenceUser()">
                                        <a href="javascript: void(0)" :class="(tab=='settings')?'active':'custom-deactive-btn'" @click="changeTab('settings')">
                                        {{ $t('settings') }}
                                        </a>
                                    </li>

                                    <li v-if="getPower('editAdminSettings')">
                                        <a href="javascript: void(0)" :class="(tab=='admin')?'active':'custom-deactive-btn'" @click="changeTab('admin')">
                                            {{ $t('admin_settings') }}
                                        </a>
                                    </li>

                                    <li v-if="disabledFrelenceUser()">
                                        <a v-if="getNoteAccess()" href="javascript: void(0)" :class="(tab=='notes')?'active' : 'custom-deactive-btn'" @click="changeTab('notes')">
                                            {{ $t('notes_and_documents') }}
                                        </a>
                                    </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <editEmployeePersonal :empDetails="employeeDetails" v-show="this.tab == 'personal'" v-if="apiStatus"/>

                <editEmployeeSkills :empDetails="employeeDetails" :hide-skill-stars="hideSkillStars" v-show="this.tab == 'skill'" v-if="apiStatus"/>

                <editEmployeeAvailability :empDetails="employeeDetails" v-show="this.tab == 'availability'" v-if="apiStatus"/>

                <settings :empDetails="employeeDetails" v-show="this.tab == 'settings'" v-if="apiStatus" />

                <editEmployeeAdmin :empDetails="employeeDetails" v-show="this.tab == 'admin'" v-if="apiStatus"/>

                <employeeNotes :empDetails="employeeDetails" v-show="this.tab == 'notes'" v-if="apiStatus"/>

            </div>
            <div v-if="btnLoading" v-loading="btnLoading" element-loading-text="Please wait..." class="loading-block"></div>
            
            <employeeSearch v-if="!searchOpen" :searchString="search_query" :requestPage="'edit-employee'"></employeeSearch>

        </div>
        <div v-else>
            <NotAllowed />
        </div>
    </div>
</template>
<script>
    import editEmployeePersonal from './editEmployeePersonal';
    import editEmployeeAdmin from './editEmployeeAdmin';
    import editEmployeeSkills from './editEmployeeSkills';
    import editEmployeeAvailability from './editEmployeeAvailability';
    import employeeSearch from './employeeSearch';
    import settings from './employeeSettings';
    import employeeNotes from './employeeNotes';
    import NotAllowed from '@/components/NotAllowed';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import {bus} from '../../main';
    import service from '../../services.js';
    import { mapGetters, mapActions } from 'vuex';
    import { customFieldValue } from '../../customFieldRules.js';   // #2030
    export default {

        components: {
            'editEmployeePersonal': editEmployeePersonal,
            'editEmployeeAdmin': editEmployeeAdmin,
            'editEmployeeSkills': editEmployeeSkills,
            'editEmployeeAvailability': editEmployeeAvailability,
            'employeeSearch':employeeSearch,
            'settings':settings,
            'employeeNotes':employeeNotes,
            'NotAllowed': NotAllowed
        },
        data() {
            return {
                isEmployeeAllowed: true,
                imageUrl: '',
                btnLoading: false,
                tab: "personal",
                apiStatus: false,
                employeeDetails: [],
                custom_field_1:'',
                custom_field_2:'',
                personalInfo: {
                    basicInfo: {
                        userName: '',
                        password: '',
                        cnfPassword: '',
                        firstName: '',
                        lastName: '',
                    },
                    address: {
                        streetAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    PoBoxAddress: {
                        pbAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    contact: {
                        email: '',
                        secEmail: '',
                        homePhone: '',
                        cellPhone: '',
                    },
                    identityField: {
                        driverLicense: '',
                        socialSecurity: '',
                        monthMaidenName: '',
                        dataOfBirth: '',
                    },
                    emergency: {
                        contactName: '',
                        contactNumber: '',
                        medicalCondition: '',
                        regularMedication: '',
                        homePhone: '',
                        cellPhone: '',
                        email: '',
                    },
                    new_files: [],
                    customFields:{
                        custom_field_1:'',
                        custom_field_2:'',
                    }
                },
                skillData: {
                    selectedSkills: [],
                    updateAuthority: '',
                    configSkillLock:'',
                    skillStars: {},
                },
                adminSettingsData: {
                    memberSince: '',
                    dateOfHire: '',
                    totalShifts: '',
                    seniority: '',
                    status: '',
                },
                weeklyVacationData: {
                    sun: '',
                    mon: '',
                    tue: '',
                    wed: '',
                    thu: '',
                    fri: '',
                    sat: '',
                },
                emailExists:'',
                oldEmail:'',
                profileImage:'',
                employeePhone:[],
                // =======================

                // afterApi:false,
                // loading:false,
                search_query:'',
                wishlistLock:false,
                hideSkillStars:false,   // #2033 — clients.hide_skill_stars
                ignorelistLock:false,
                // last_page:'',
                // next_page:'',
                // employees:[],
                // savedEmployees:[],
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                getEditEmployeeFrom: 'getEditEmployeeFrom',
                employeeId:'employeeId',
                userRoleSlug: 'userRoleSlug',
                userID: 'userID',
                subDomain: 'getSubdomain',
                editUserTab: 'editUserTab',
                userName: 'userName',
                userFullName: 'userFullName',
            }),

            // ==========================================

            searchOpen(){
                return (this.search_query.length==0)?true:false;
            },
        },
        methods: {
            getErrorMessage(errorMessage) {
                let msg = 'Something went wrong'
                if(errorMessage.cell_phone&&errorMessage.cell_phone.length) {
                    msg = errorMessage.cell_phone[0]
                } else if((typeof errorMessage) == 'string') {
                    let errMsg = JSON.parse(errorMessage);
                    if(errMsg.email&&errMsg.email.length) {
                        msg = errMsg.email[0]
                    }
                } 
                // console.log(errorMessage.email[0]);
                return msg;
            },

            disabledFrelenceUser(){
                return dateTimeConvert.disabledFrelenceUser();
            },

            getNoteAccess(){
              if(this.employeeDetails.notes_documents=='enabled' || this.userRoleSlug=='client-admin' || this.userRoleSlug=='power-user'){
                return true;
              }else{
                return false;
              }
            },

            viewSchedule(){
                this.$router.push({
                    'path': '/schedule/'+this.$route.params.empId
                });
            },

            goToEmployeeList(){
                // this.$router.push({
                //     'path': '/employees'
                // });
                this.$router.go(-1);
            },

            goToWishlist(){
                this.$router.push({
                    'path': '/wishlist/'+this.$route.params.empId
                });
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            changeTab(newTab) {
                this.$store.dispatch('setEditUserTab', newTab);
                this.tab = newTab;
            },

            goToEmployee() {
                if (this.getEditEmployeeFrom == 'editMyProfile') {
                    this.$router.push({
                        path: `/myProfile`
                    });
                }else if(this.getEditEmployeeFrom == 'empSchedule'){
                    this.$router.push({
                        path: `/schedule/`+this.$route.params.empId
                    });
                } else if (this.getEditEmployeeFrom == 'employeeDetails') {
                    this.$router.push({
                        path: `/employeeDetails/`+this.$route.params.empId
                    });
                }else {
                    this.$router.push({
                        path: `/employees`
                    });
                }
            },

            getAvailabilityFormat(dayInput) {
                if (dayInput != "") {
                    let unavailabilityList = dayInput.split(",");
                    let fomatedUnavailabilityList = {};
                    if (unavailabilityList.length > 0) {
                        for (let i = 0; i < unavailabilityList.length; i++) {
                            let fullDate = [];
                            let start = unavailabilityList[i].split("-")[0];
                            let end = unavailabilityList[i].split("-")[1];
                            fullDate.push(start);
                            fullDate.push(end);
                            fomatedUnavailabilityList[i + 1] = fullDate;
                        }
                        return fomatedUnavailabilityList;
                    } else {
                        return {};
                    }
                } else {
                    return {};
                }
            },

            isPhoneErr(phone, type){  
                if(type == 'cell'){
                    // var patt=/^\d{10,12}$/g;
                    if(phone != ''){
                        if(phone.length < 10){
                            return true;
                        }
                        if(phone.length > 15){
                            return true
                        }

                        return false;
                    }
                    else {
                        return false;
                    }

                }else{
                    // var patt=/^\d{10,12}$/g;
                    if(phone != ''){
                        if(phone.length < 10){
                            return true;
                        }
                        if(phone.length > 15){
                            return true
                        }
                        return false;
                    }
                    else {
                        return false;
                    }
                }               
            },

            async uploadService() {
                if (this.personalInfo.new_files.length != 0) {
                    this.btnLoading=true;
                    await service.post('attachment/uploadSingleFile', {
                            'image_file': this.personalInfo.new_files[0].img,
                            'file_name': this.personalInfo.new_files[0].name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then(async (res) => {
                            this.personalInfo.new_files[0].path = res.data.result.path;
                            this.personalInfo.new_files[0].uploaded = true;
                                // this.$store.dispatch('setUserImage', res.data.result.path);
                            this.imageUrl = res.data.result.path
                            this.btnLoading = false;
                        }).catch((err) => {
                            console.log(err);
                            this.$message({
                                type: 'error',
                                message: this.$t('something_went_wrong')
                            });
                        });
                } 
                // await this.openPhoneEmptyCheckConfirm();
                await this.saveEmployeeData();
            },
            
            async openPhoneEmptyCheckConfirm() {
                let home_phone = this.personalInfo.contact.homePhone;
                let cell_phone = this.personalInfo.contact.cellPhone;
                if(home_phone == '' || home_phone == 0 || cell_phone == 0 || cell_phone == '') {
                    this.$confirm('One or Both of your phone numbers are missing! Continue?', 'Warning', {
                        confirmButtonText: 'Continue',
                        cancelButtonText: 'Cancel',
                        type: 'warning',
                        }).then(async () => {
                            await this.saveEmployeeData();
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Employee Update canceled'
                        });          
                    });

                }else {
                    await this.saveEmployeeData();
                }
            },

            async customValEmail(customEmailField) {
                if(customEmailField == this.oldEmail){
                    this.emailExists = 1;
                    return;
                }else{
                    if (customEmailField != "") {
                        const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,10})(\]?)$/;
                        if (filter.test(customEmailField)) {
                            await service.get('user/emailExists', {
                                'Authorization': this.userToken,
                                'email': customEmailField,
                            }).then((res) => {
                                this.emailExists=res.data.result;
                                if(this.emailExists==0){
                                    this.$message({
                                        type: 'error',
                                        message: this.$t('email_already_exist')
                                    });
                                }

                            }).catch((err) => {
                                console.log(err);
                                this.emailExists=0;
                                this.$message({
                                    type: 'error',
                                    message:this.$t('email_already_exist')
                                });
                                return this.emailExists;
                            });
                        } else {
                            this.emailExists=-1;
                            this.$message({
                                type: 'error',
                                message: this.$t('please_enter_valid_email')
                            });
                            //return false;
                        }
                    } else {
                        this.emailExists=-1;
                        this.$message({
                            type: 'error',
                            message: this.$t('please_enter_valid_email')
                        });
                        //return false;
                    }
                }
            },

            async saveEmployeeData() {
                let availabilityData = {
                    "1": this.getAvailabilityFormat(this.weeklyVacationData.sun),
                    "2": this.getAvailabilityFormat(this.weeklyVacationData.mon),
                    "3": this.getAvailabilityFormat(this.weeklyVacationData.tue),
                    "4": this.getAvailabilityFormat(this.weeklyVacationData.wed),
                    "5": this.getAvailabilityFormat(this.weeklyVacationData.thu),
                    "6": this.getAvailabilityFormat(this.weeklyVacationData.fri),
                    "7": this.getAvailabilityFormat(this.weeklyVacationData.sat)
                };
                let addEmpData = {
                    client_id: this.userClientID,
                    display_name: this.personalInfo.basicInfo.userName,
                    first_name: this.personalInfo.basicInfo.firstName,
                    last_name: this.personalInfo.basicInfo.lastName,
                    // password: this.personalInfo.basicInfo.password,
                    email: this.personalInfo.contact.email,
                    secondary_email: this.personalInfo.contact.secEmail,
                    drivers_license: this.personalInfo.identityField.driverLicense,
                    social_security: this.personalInfo.identityField.socialSecurity,
                    dob: (this.personalInfo.identityField.dataOfBirth != "") ? this.personalInfo.identityField.dataOfBirth + " " + Date().slice(16, 24) : "",
                    mothers_maiden_name: this.personalInfo.identityField.monthMaidenName,
                    total_shifts: this.adminSettingsData.totalShifts,
                    member_since: (this.adminSettingsData.memberSince != "") ? this.adminSettingsData.memberSince + " " + Date().slice(16, 24) : "",
                    date_of_hire: (this.adminSettingsData.dateOfHire != "") ? this.adminSettingsData.dateOfHire + " " + Date().slice(16, 24) : "",
                    sreet_address: this.personalInfo.address.streetAdd,
                    sreet_city: this.personalInfo.address.city,
                    street_state: this.personalInfo.address.state,
                    street_postcode: this.personalInfo.address.zip,
                    street_country: this.personalInfo.address.country,
                    po_box_address: this.personalInfo.PoBoxAddress.pbAdd,
                    po_box_city: this.personalInfo.PoBoxAddress.city,
                    po_box_state: this.personalInfo.PoBoxAddress.state,
                    po_box_postcode: this.personalInfo.PoBoxAddress.zip,
                    po_box_country: this.personalInfo.PoBoxAddress.country,
                    home_phone: this.personalInfo.contact.homePhone,
                    cell_phone: this.personalInfo.contact.cellPhone,
                    skills: JSON.stringify(this.skillData.selectedSkills),
                    skill_stars: JSON.stringify(this.skillData.skillStars || {}),     // #1953
                    skill_lock: (this.skillData.updateAuthority=='locked') ? 1 : 0,
                    employee_status_id: this.adminSettingsData.status,
                    vacation_start: '',
                    vacation_end: '',
                    image: this.imageUrl!=''?this.imageUrl:this.profileImage && this.profileImage != ''?this.profileImage:null,
                    available_times: JSON.stringify(availabilityData),
                    seniority: this.adminSettingsData.seniority,
                    custom_field1: JSON.stringify({'name':this.custom_field_1, 'value':this.personalInfo.customFields.custom_field_1}), 
                    custom_field2: JSON.stringify({'name':this.custom_field_2, 'value':this.personalInfo.customFields.custom_field_2}),
                };
                if(this.getEmergencyContactStatus(this.personalInfo.emergency)) {
                    addEmpData.contact_name = this.personalInfo.emergency.contactName;
                    addEmpData.contact_number = this.personalInfo.emergency.contactNumber;
                    addEmpData.medical_conditions_note = this.personalInfo.emergency.medicalCondition;
                    addEmpData.regular_medications = this.personalInfo.emergency.regularMedication;
                    addEmpData.home_phone_no = this.personalInfo.emergency.homePhone;
                    addEmpData.cell_phone_no = this.personalInfo.emergency.cellPhone;
                    addEmpData.emergency_email = this.personalInfo.emergency.email;
                }
                // console.log(this.imageUrl);
                // console.log(addEmpData.image);
                if(this.personalInfo.basicInfo.password != ''){
                    addEmpData.password = this.personalInfo.basicInfo.password;
                }
                await this.customValEmail(addEmpData.email);

                // if(addEmpData.home_phone == '' || addEmpData.home_phone == 0 || addEmpData.cell_phone == 0 || addEmpData.cell_phone == '') {
                //     this.$message({
                //         type: 'error',
                //         message: 'Both or one of your Phone Numbers are empty'
                //     });   
                // }

                // image: 'https://storage.googleapis.com/cs3bucket/public_files/481656934418.jpg',

                if(addEmpData.first_name =='' || addEmpData.last_name == '' || this.emailExists != 1 || this.isPhoneErr(addEmpData.cell_phone, 'cell') || this.isPhoneErr(addEmpData.home_phone, 'home')){
                    // console.log(addEmpData.first_name)
                    // console.log(addEmpData.last_name)
                    // console.log(this.emailExists)
                    // console.log(this.isPhoneErr(addEmpData.cell_phone, 'cell'))
                    // console.log(this.isPhoneErr(addEmpData.cell_phone, 'home'))

                    // console.log("Error Found")
                    this.$message({
                        type: 'error',
                        message: this.$t('please_input_personal_information_fields_correctly')
                    });
                }else if(JSON.parse(addEmpData.skills).length == 0){
                    this.$message({
                        type: 'error',
                        message: this.$t('profile_error_skill')
                    });    
                }else if(addEmpData.employee_status_id ==''){
                    this.$message({
                        type: 'error',
                        message: this.$t('profile_error_admin_status')
                    });
                }else{
                    this.$confirm(this.$t('please_input_your_note'), this.$t('note'), {
                        confirmButtonText: this.$t('okay'),
                        cancelButtonText: this.$t('cancel'),
                        showInput: true,
                        inputErrorMessage: this.$t('invalid')
                        }).then(async({value}) => {
                            var activityID = {
                                "uploader_id": this.userID,
                                "uploaded_by": this.userFullName,
                            };
                            activityID = JSON.stringify(activityID);
                            addEmpData.activity = activityID;
                            addEmpData.note_content = value;
                            this.btnLoading = true;
                            await service.put('employee/' + atob(this.$route.params.empId), addEmpData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID
                            }).
                            then((res) => {
                                this.btnLoading = false;
                                let resData = res.data;
                                if(resData.status_code==0){
                                    this.$message({
                                        type: 'error',
                                        message: resData.status_message
                                            ? this.getErrorMessage(resData.status_message)
                                            : this.$t('something_went_wrong')
                                    });
                                        // message: (res.data['status_message']) ? (res.data['status_message'][0] == "mailbox_does_not_exist" ? this.$t(res.data['status_message'][0]) : res.data['status_message'][0]) : this.$t('something_went_wrong')
                                    return;
                                }else if(resData) {
                                    this.$message({
                                        type: 'success',
                                        message: this.$t('employee_updated_successfully')
                                    });
                                    this.getEmpDetails();
                                    if(atob(this.$route.params.empId)==this.employeeId) {
                                        this.$store.dispatch('setUserImage', this.imageUrl);
                                    }
                                } else{
                                    this.$message({
                                        type: 'error',
                                        message: status_message.toString()
                                    });
                                }
                                
                            }).catch((err) => {
                                console.log(err);
                                this.$message({
                                        type: 'error',
                                        message: this.$t('something_went_wrong')
                                    });
                        });
                    }).catch(() => {
                        this.btnLoading = false;
                        bus.$emit('updateNoteCancel');
                        this.$message({
                            type: 'info',
                            message: this.$t('employee_update_note_canceled')
                        });       
                    });
                    this.btnLoading = false;
                }
            },

            getEmergencyContactStatus(contact) {
                let result = true;
                console.log(contact);
                if(contact.contactName==''&&contact.contactNumber==''&&contact.medicalCondition==''&&contact.regularMedication==''&&contact.homePhone==''&&contact.cellPhone==''&&contact.email==''){
                    result = false;
                }
                return result;
            },

            async openAddNotePromptSaveEdit(addEmpData,value) {

                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                addEmpData.activity = activityID;
                addEmpData.note_content = value;
                service.put('employee/' + atob(this.$route.params.empId), addEmpData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    if(res.data.status_code==0){
                        this.$message({
                            type: 'error',
                            message: (res.data['status_message'])?res.data['status_message'][0]:this.$t('something_went_wrong')
                        });
                        return;
                    }
                    this.$message({
                        type: 'success',
                        message: this.$t('employee_updated_successfully')
                    });
                    // if (this.getEditEmployeeFrom == 'editMyProfile') {
                    //     this.$router.push({
                    //         path: `/myProfile`
                    //     });
                    // } else if (this.getEditEmployeeFrom == 'employeeDetails') {
                    //     this.$router.push({
                    //         path: `/employeeDetails/`+ this.$route.params.empId
                    //     });
                    // } else if(this.getEditEmployeeFrom == 'empSchedule'){
                    //     this.$router.push({
                    //         path: `/schedule/`+this.$route.params.empId
                    //     });
                    // }else {
                    //     this.$router.push({
                    //         path: `/employees`
                    //     });
                    // }
                }).catch((err) => {
                    console.log(err);
                });
                
            },

            async getEmpDetails() {
                let self = this;
                this.$Progress.start();
                this.apiStatus = false;
                this.btnLoading = true;
                await service.get('employee/' + atob(this.$route.params.empId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //this.venues = res.data.result.data;
                    this.$Progress.finish();
                    const response = res.data.result;
                    this.employeeDetails = response;
                    this.profileImage=res.data.result.employable?res.data.result.employable.image:null;
                    this.employeePhone=res.data.result.employable?res.data.result.employable.phones:[];
                    this.employeeDetails.configSkillLock=this.skillData.configSkillLock;
                    //console.log("Get Emp Details", this.employeeDetails);
                    this.apiStatus = true;
                    this.personalInfo.basicInfo.userName = this.employeeDetails.employable.display_name;
                    this.personalInfo.basicInfo.firstName = this.employeeDetails.employable.first_name;
                    this.personalInfo.basicInfo.lastName = this.employeeDetails.employable.last_name;
                    let fname = this.employeeDetails&&this.employeeDetails.employable&&this.employeeDetails.employable.first_name?this.employeeDetails.employable.first_name:'Employee Details';
                    let lname = this.employeeDetails&&this.employeeDetails.employable&&this.employeeDetails.employable.last_name?this.employeeDetails.employable.last_name:'';
                    document.title = lname + ', ' + fname;
                    this.oldEmail=this.employeeDetails.employable.email;
                    this.personalInfo.contact.email = this.employeeDetails.employable.email;
                    this.personalInfo.contact.secEmail = this.employeeDetails.employable.secondary_email;
                    //this.personalInfo.contact.homePhone = this.employeeDetails.employable.secondary_email;
                    this.personalInfo.identityField.driverLicense = this.employeeDetails.employable.drivers_license;
                    this.personalInfo.identityField.socialSecurity = this.employeeDetails.employable.social_security;
                    this.personalInfo.identityField.monthMaidenName = this.employeeDetails.employable.mothers_maiden_name;
                    this.personalInfo.identityField.dataOfBirth = (this.employeeDetails.employable.dob != null) ? this.employeeDetails.employable.dob.split(" ")[0] : "";

                    this.adminSettingsData.status = (this.employeeDetails.employee_status) ? this.employeeDetails.employee_status.id : '';
                    this.adminSettingsData.memberSince = (this.employeeDetails.member_since != null && this.employeeDetails.member_since != '0000-00-00 00:00:00') ? this.employeeDetails.member_since.split(" ")[0] : "";
                    this.adminSettingsData.dateOfHire = (this.employeeDetails.date_of_hire != null && this.employeeDetails.date_of_hire != '0000-00-00 00:00:00') ? this.employeeDetails.date_of_hire.split(" ")[0] : "";
                    this.adminSettingsData.totalShifts = this.employeeDetails.total_shifts;
                    this.adminSettingsData.seniority = this.employeeDetails.seniority;

                    this.employeeDetails.skills.forEach(function(skill) {
                        self.skillData.selectedSkills.push(skill.id);
                        //console.log(skill.id);
                    });

                    this.skillData.updateAuthority = (this.employeeDetails.skill_lock) ? 'locked' : 'unlocked';

                    if (this.employeeDetails.employable.addresses.length > 0) {
                        for (let i = 0; i < this.employeeDetails.employable.addresses.length; i++) {
                            switch (this.employeeDetails.employable.addresses[i].label) {
                                case 'Street':
                                    this.personalInfo.address.streetAdd = this.employeeDetails.employable.addresses[i].address;
                                    this.personalInfo.address.city = this.employeeDetails.employable.addresses[i].municipality;
                                    this.personalInfo.address.state = this.employeeDetails.employable.addresses[i].state_province;
                                    this.personalInfo.address.zip = this.employeeDetails.employable.addresses[i].postcode;
                                    break;
                                case 'office':
                                    this.personalInfo.address.streetAdd = this.employeeDetails.employable.addresses[i].address;
                                    this.personalInfo.address.city = this.employeeDetails.employable.addresses[i].municipality;
                                    this.personalInfo.address.state = this.employeeDetails.employable.addresses[i].state_province;
                                    this.personalInfo.address.zip = this.employeeDetails.employable.addresses[i].postcode;
                                    //console.log('office address');
                                    break;
                                case 'P O box':
                                    this.personalInfo.PoBoxAddress.pbAdd = this.employeeDetails.employable.addresses[i].address;
                                    this.personalInfo.PoBoxAddress.city = this.employeeDetails.employable.addresses[i].municipality;
                                    this.personalInfo.PoBoxAddress.state = this.employeeDetails.employable.addresses[i].state_province;
                                    this.personalInfo.PoBoxAddress.zip = this.employeeDetails.employable.addresses[i].postcode;
                                    break;
                                default:
                                    this.personalInfo.address.streetAdd = "";
                                    this.personalInfo.PoBoxAddress.pbAdd = "";
                                    this.personalInfo.address.city = "";
                                    this.personalInfo.address.state = "";
                                    this.personalInfo.address.zip = "";
                                    this.personalInfo.PoBoxAddress.city = "";
                                    this.personalInfo.PoBoxAddress.state = "";
                                    this.personalInfo.PoBoxAddress.zip = "";
                            }
                        }
                    } else {
                        this.personalInfo.address.streetAdd = "";
                        this.personalInfo.PoBoxAddress.pbAdd = "";
                        this.personalInfo.PoBoxAddress.pbAdd = "";
                        this.personalInfo.address.city = "";
                        this.personalInfo.address.state = "";
                        this.personalInfo.address.zip = "";
                        this.personalInfo.PoBoxAddress.city = "";
                        this.personalInfo.PoBoxAddress.state = "";
                        this.personalInfo.PoBoxAddress.zip = "";
                    }

                    if (this.employeeDetails.employable.phones.length > 0) {
                        for (let i = 0; i < this.employeeDetails.employable.phones.length; i++) {
                            switch (this.employeeDetails.employable.phones[i].label) {
                                case 'Home phone':
                                    this.personalInfo.contact.homePhone = this.employeeDetails.employable.phones[i].phone_number;

                                    break;
                                case 'home':
                                    this.personalInfo.contact.homePhone = this.employeeDetails.employable.phones[i].phone_number;

                                    break;
                                case 'Cell phone':
                                    this.personalInfo.contact.cellPhone = this.employeeDetails.employable.phones[i].phone_number;
                                    break;
                                case 'cell':
                                    this.personalInfo.contact.cellPhone = this.employeeDetails.employable.phones[i].phone_number;
                                    break;
                                default:
                                    // this.personalInfo.contact.homePhone = "";
                                    // this.personalInfo.contact.cellPhone = "";
                            }
                        }
                    } else {
                        this.personalInfo.contact.homePhone = "";
                        this.personalInfo.contact.cellPhone = "";
                    }

                    if (this.employeeDetails.emergency_contact&&this.employeeDetails.emergency_contact.length > 0) {
                        this.personalInfo.emergency.contactName = this.employeeDetails.emergency_contact[0].contact_name;
                        this.personalInfo.emergency.contactNumber = this.employeeDetails.emergency_contact[0].contact_number;
                        this.personalInfo.emergency.medicalCondition = this.employeeDetails.emergency_contact[0].medical_conditions_note;
                        this.personalInfo.emergency.regularMedication = this.employeeDetails.emergency_contact[0].regular_medications;
                        this.personalInfo.emergency.homePhone = this.employeeDetails.emergency_contact[0].home_phone_no;
                        this.personalInfo.emergency.cellPhone = this.employeeDetails.emergency_contact[0].cell_phone_no;
                        this.personalInfo.emergency.email = this.employeeDetails.emergency_contact[0].email;
                    }

                    // this.personalInfo.customFields.custom_field_1= this.employeeDetails.custom_field1;
                    // this.personalInfo.customFields.custom_field_2=this.employeeDetails.custom_field2;

                    // #2030 — THIS is where the nesting came from. These two lines loaded
                    // the RAW stored JSON into the text inputs, so the box showed
                    // {"name":"Notes","value":""} and the save below (line ~555) wrapped it
                    // in ANOTHER {name, value} — a valid but nested value. Owner Options then
                    // re-stamped it by string concatenation and the nesting became invalid
                    // JSON, which is what blanked local 24's phone sheet. editEmployeePersonal
                    // always loaded the parsed value here; this screen did not.
                    this.personalInfo.customFields.custom_field_1= customFieldValue(this.employeeDetails.custom_field1, '');
                    this.personalInfo.customFields.custom_field_2= customFieldValue(this.employeeDetails.custom_field2, '');
                    this.getAvailibityList = JSON.parse(this.employeeDetails.available_times);
                    if(this.getAvailibityList) {
                        this.weeklyVacationData.sun = this.getAvailByDay(this.getAvailibityList['1']);
                        this.weeklyVacationData.mon = this.getAvailByDay(this.getAvailibityList['2']);
                        this.weeklyVacationData.tue = this.getAvailByDay(this.getAvailibityList['3']);
                        this.weeklyVacationData.wed = this.getAvailByDay(this.getAvailibityList['4']);
                        this.weeklyVacationData.thu = this.getAvailByDay(this.getAvailibityList['5']);
                        this.weeklyVacationData.fri = this.getAvailByDay(this.getAvailibityList['6']);
                        this.weeklyVacationData.sat = this.getAvailByDay(this.getAvailibityList['7']);
                    }
                    // this.btnLoading = false;
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
                this.btnLoading = false;
            },

            getAvailByDay(day) {
                if(day==null) return;
                let daycount = "";
                /* day.forEach(function(dayslot) {
                     
                     daycount = daycount + "," + dayslot[0] + "-" + dayslot[1];
                 });
                 console.log("daycount", daycount);
                 return daycount;*/
                for (let i = 0; i < Object.keys(day).length; i++) {
                    if(daycount != "") {
                        daycount = daycount + "," + day[i + 1][0] + "-" + day[i + 1][1];
                    } else {
                        daycount = day[i + 1][0] + "-" + day[i + 1][1];
                    }

                }
                return daycount;
            },

            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            }

            // ==================================================


            // getAllEmployee() {
            //     this.$Progress.start();
            //     this.loading = true;
            //     this.afterApi = false;
            //     this.employees=[];
            //     this.savedEmployees =[];
            //     service.get('employee/getEmployeesByClient', {
            //         'Authorization': this.userToken,
            //         'cs3-context-role': this.userRole,
            //         'cs3-context-clientId': this.userClientID,
            //         'status': 'all',
            //         'sort': 'fname_asc',
            //         'search': this.search_query,
            //         'pagination': true
            //     }).then((res) => {
            //         this.employees = res.data.result.data;
            //         this.$Progress.finish();
            //         this.last_page = res.data.result.total;
            //         this.next_page = res.data.result.next_page_url;
            //         this.loading = false;
            //         this.afterApi = true;
            //         //this.sortEmployee();
            //         if (this.next_page != null || this.next_page != "") {
            //             service.getUrl(this.next_page, {
            //                 'Authorization': this.userToken,
            //                 'cs3-context-role': this.userRole,
            //                 'cs3-context-clientId': this.userClientID,
            //                 'status': 'all',
            //                 'sort': 'fname_asc',
            //                 'search': this.search_query,
            //                 'pagination': true
            //             }).then((res) => {
            //                 this.savedEmployees = res.data.result.data;
            //                 this.next_page = res.data.result.next_page_url;

            //             }).catch((err) => {
            //                 console.log(err);
            //             });
            //         } 
            //     }).catch((err) => {
            //         console.log(err);
            //         this.loading = false;
            //         this.afterApi = true;
            //     });
            // },
            // loadMore() {
            //     var arr = this.employees;
            //     if (this.savedEmployees.length != 0) {
            //         this.savedEmployees.forEach(function(entry) {
            //             arr.push(entry);
            //         })
            //         this.savedEmployees=[];
            //         if (this.next_page != null || this.next_page != "") {
            //             service.getUrl(this.next_page, {
            //                 'Authorization': this.userToken,
            //                 'cs3-context-role': this.userRole,
            //                 'cs3-context-clientId': this.userClientID,
            //                 'status': 'all',
            //                 'sort': 'fname_asc',
            //                 'search': this.search_query,
            //             }).then((res) => {
            //                 this.savedEmployees = res.data.result.data;
            //                 this.page_no += 1;
            //                 this.next_page = res.data.result.next_page_url;

            //             }).catch((err) => {
            //                 console.log(err);
            //             });
            //         }
            //     } 
            // },
            // goToEmployeeList(){
            //     this.$router.push({
            //         'path': '/employees'
            //     });
            // },
            // goToEmployeeDetails(employee) {
            //     this.$store.dispatch('selectEmployee', {
            //         'id': employee.employee_id,
            //         'name': employee.employable.first_name + ' ' + employee.employable.last_name,
            //         'type': employee.employable_type
            //     });
            //     this.$router.push({
            //         path: '/employeeDetails/' + btoa(employee.employee_id)
            //     });
            // },
            // editEmployee(employee) {
            //     this.$store.dispatch('selectEmployee', {
            //         'id': employee.employee_id,
            //         'name': employee.employable.first_name + ' ' + employee.employable.last_name,
            //         'type': employee.employable_type
            //     });
            //     this.$store.dispatch('setEditEmployeesFrom', 'editEmployeeList');
            //     this.search_query='';
            //     // location.href=window.location.href.split('/#/')[0]+'/#/editEmployee/'+btoa(employee.employee_id);
                
            //     this.$router.push({ name: 'editEmployee', params: { empId: btoa(employee.employee_id) } })
            //     this.getEmpDetails();
                 
            //     // this.$router.push({
            //     //     'path': '/editEmployee/'+btoa(employee.employee_id)
            //     // });
            // },
            // goToSchedule(empId){
            //     this.$router.push({
            //         'path': '/schedule/'+btoa(empId)
            //     });
            // },
        },
        created() {
            service.get('client/'+this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                this.ignorelistLock=(res.data.result.ignorelist_lock == 1)?true:false;  
                this.wishlistLock=(res.data.result.wishlist_lock == 1)?true:false;  

                this.custom_field_1=res.data.result.custom_field_1;
                this.custom_field_2=res.data.result.custom_field_2;

                this.skillData.configSkillLock=res.data.result.skill_lock;
                // #2033 — the Owner Options switch, read off the same client record this
                // already fetches. Absent/NULL/0 all mean SHOWN.
                this.hideSkillStars = (res.data.result.hide_skill_stars == 1);
            }).catch((err) => {
                console.log(err);
            });

            if(this.$route.query&&this.$route.query.tab&&this.$route.query.tab!='') {
                this.changeTab(this.$route.query.tab);
                const query = Object.assign({}, this.$route.query);
                delete query.tab;
                this.$router.replace({ query });                
            }else if(this.editUserTab && this.editUserTab != ''){
                this.changeTab(this.editUserTab);
            }

            bus.$on('onUpdateOrAdd', (data) => {
                this.getEmpDetails();
            });
            this.getEmpDetails();

            bus.$on('onUpdatePersonalDetails', (data) => {
                this.personalInfo = data;
            });
            bus.$on('onUpdateSkillList', (data) => {
                this.skillData = data;
            });
            bus.$on('onUpdateAdminSettings', (data) => {
                this.adminSettingsData = data;
            });
            bus.$on('onUpdateVacation', (data) => {
                this.weeklyVacationData = data;
                this.uploadService();
            });
            bus.$on('onsearchAction', (data) => {
              if(data=='edit-employee'){
                this.getEmpDetails();
                this.search_query='';
              }
            });
        },
    }

</script>
<style scoop>
.header-value{
    color: #000!important;
    text-transform: capitalize;
}
.loading-block {
    min-height: 300px;
    min-width: 600px;
    margin: 50px auto;
}
.search-input-employee{
    margin: 1px;
    height: 35px;
}

</style>
